const STATIONS = [
  "Manchester Picadilly",
  "London Euston",
  "Liverpool Street",
  "Blackhorse Road",
  "London Bridge",
  "Meridian Water",
  "Canonbury",
  "Old Street"
];
const AMENITIES = [
  { name: "Wifi", description: "Enjoy fast speeds" },
  { name: "Air Conditioner" },
  { name: "Extra Leg Space", description: "Enjoy extra leg space" }
];
const DISRUPTIONS = [
  "Industrial action to affect National Rail services until 26 June. Trains on Wednesday 22 June are showing correctly in the journey planner. If you are travelling by train today please check your last train, as it may be a lot earlier than usual. Visit www.nationalrail.co.uk/industrialaction for more information",
  "Rail strikes will impact travel from Tuesday 2st to Sunday 26th of June. See here for details more info",
  "TOC test, disruption at Kings Cross. more info"
];
export {
  AMENITIES,
  DISRUPTIONS,
  STATIONS
};
